import { makeStyles } from '@material-ui/styles';

import { green, neutral } from 'shared/styles/colors';

import type { ZappieChipSize } from './zappieChip.type';

export default makeStyles({
  root: ({ size }: Props) => ({
    height: 'fit-content',
    width: 'fit-content',
    padding: size === 'regular' ? '0.125rem 0.5rem' : '0 0.5rem',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: green[70],
    borderRadius: '1.25rem',
    backgroundColor: neutral.white,
    border: `1px solid ${neutral[10]}`,
  }),
});

interface Props {
  size: ZappieChipSize;
}
